import { useState } from "react";
import { post } from "../networking/RequestService";

const useTaskComplete = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const completeTask = async (taskId) => {
        setLoading(true);
        setError(null);
        try {
            const res = await post({
                fn: "gorevTamamla",
                gorev: taskId,
                multiple: false,
            });
            return res.data;
        } catch (res) {
            setError(res.response.data.text);
            throw res.response.data.text;
        } finally {
            setLoading(false);
        }
    };

    const bulkCompleteTasks = async (taskIds) => {
        setLoading(true);
        setError(null);
        try {
            const res = await post({
                fn: "gorevTamamla",
                gorev: taskIds,
                multiple: true,
            });
            return res.data;
        } catch (res) {
            setError(res.response?.data?.text || res.message);
            throw res.response?.data?.text || res.message;
        } finally {
            setLoading(false);
        }
    };

    return { completeTask, bulkCompleteTasks, loading, error };
};

export default useTaskComplete;
